import {createBrowserRouter} from "react-router-dom";
import {Navigate} from "react-router-dom";
import DefaultLayout from "../pages/layouts/DefaultLayout";
import Dashboard from "../pages/Private/Dashboard";
import Users from "../pages/Private/Users";
import Informations from "../pages/Private/Informations";
import Banner from "../pages/Private/Banner";
import Partners from "../pages/Private/Partners";
import GuestLayout from "../pages/layouts/GuestLayout";
import Login from "../pages/Public/Login";
import Donations from "../pages/Private/Donations"
import NotFound from "../pages/Public/NotFound";
import IndexPage from "../pages/Public/IndexPage";
import History from "../pages/Private/History";
import Suitor from "../pages/Private/Suitor";
import Animals from "../pages/Private/Animals";
import AnimalImage from "../pages/Private/AnimalImages";
import AnimalsPage from "../pages/Public/AnimalPage/Animalsindex";


const router = createBrowserRouter([
  {
    path: '/admin',
    element: <DefaultLayout />,
    children: [
      {
        path: '/admin',
        element: <Navigate to="/admin/dashboard" />,
        abstract: true,
        title: 'Dashboard',
        description: 'Dashboard',
        
      },
      {
        path: '/admin/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/admin/animais',
        element: <Animals />
      },
      {
        path: '/admin/animais/imagens/:id',
        element: <AnimalImage />
      },
      {
        path: '/admin/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/admin/usuarios',
        element: <Users />,
      },
      {
        path: '/admin/doacoes',
        element: <Donations />,
      },

      {
        path: '/admin/informacoes',
        element: <Informations />
      },
        {
        path: '/admin/historia',
        element: <History />,
      },
      {
        path: '/admin/banner',
        element: <Banner />
      },
      {
        path: '/admin/pretendente',
        element: <Suitor />
      },
      {
        path: '/admin/parceiros',
        element: <Partners />
      },

    ]
  },

  {
    path: '/admin',
    element: <GuestLayout />,
    children: [
      {
        path: '/admin/login',
        element: <Login />,
      },
    ]
  },
  {
    path: '/animais',
    element: <AnimalsPage/>
  },
  {
    path: '/',
    element: <IndexPage/>
  },
  {
    path: '*',
    element: <NotFound />,
  }


]);

export default router;
